import {
	AccelerationUnit,
	NoneType,
	OverpressureUnit,
	VelocityUnit,
	VibrationSubType,
} from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";

export const defaultVibEventDataOptions = createPluginOptions()({
	vibrationType: "velocity" as VibrationSubType,
	accelerationUnit: "mm/s²" as AccelerationUnit | NoneType,
	velocityUnit: "mm/s" as VelocityUnit | NoneType,
	oplUnit: "Pa" as OverpressureUnit,
});

export type VibEventDataOptions = typeof defaultVibEventDataOptions;
